var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"px-5 px-sm-10 mt-2 mb-6",attrs:{"id":"app-main"}},[_c('AppNavigation'),_c('router-view',{staticClass:"view-container"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }